import { Component } from '@angular/core';
import SwiperCore, { Navigation,Pagination } from 'swiper';
SwiperCore.use([Navigation,Pagination ]);
@Component({
  selector: 'app-realtime-parking',
  templateUrl: './realtime-parking.page.html',
  styleUrls: ['./realtime-parking.page.scss'],
})
export class RealtimeParkingPage {
  entered=false
  refresh=0
  ionViewDidEnter(){
   if(this.entered){
    
    this.refresh++
   }
    this.entered=true
    
  }
}
